module.exports = __webpack_public_path__ + "img/maths-textbook-inactive.a1d54ac7.png";